import { writable } from 'svelte/store'
import { patchStoredSettings } from './user'

interface UIState {
  isSidebarOpen: boolean
  isDevicesOpen: boolean
  userClosedDevices: boolean
  userClosedSidebar: boolean
}

export const uiState = writable<UIState>({
  isSidebarOpen: true,
  isDevicesOpen: true,
  userClosedDevices: false,
  userClosedSidebar: false
})

function getBrowserId(): string {
  const ua = navigator.userAgent
  let hash = 0
  for (let i = 0; i < ua.length; i++) {
    const char = ua.charCodeAt(i)
    hash = ((hash << 5) - hash) + char
    hash = hash & hash
  }
  return `browser-${Math.abs(hash).toString(36)}`
}

async function saveBrowserState(sidebarOpen: boolean, devicesOpen: boolean) {
  const browserId = getBrowserId()
  try {
    patchStoredSettings({
      browserStates: {
        [browserId]: {
          sidebarOpen,
          devicesOpen
        }
      }
    })
  } catch (e) {
    console.error('Failed to save browser state:', e)
  }
}

export const toggleSidebar = () => {
  uiState.update(state => {
    const newState = {
      ...state,
      isSidebarOpen: !state.isSidebarOpen,
      userClosedSidebar: state.isSidebarOpen
    }
    saveBrowserState(newState.isSidebarOpen, state.isDevicesOpen)
    return newState
  })
}

export const toggleDevices = () => {
  uiState.update(state => {
    const newState = {
      ...state,
      isDevicesOpen: !state.isDevicesOpen,
      userClosedDevices: state.isDevicesOpen
    }
    saveBrowserState(state.isSidebarOpen, newState.isDevicesOpen)
    return newState
  })
}

export const setSidebarOpen = (open: boolean) => uiState.update(state => {
  if (state.isSidebarOpen === open) return state
  const newState = {
    ...state,
    isSidebarOpen: open,
    userClosedSidebar: !open
  }
  saveBrowserState(newState.isSidebarOpen, state.isDevicesOpen)
  return newState
})

export const setDevicesOpen = (open: boolean) => uiState.update(state => {
  if (state.isDevicesOpen === open) return state
  const newState = {
    ...state,
    isDevicesOpen: open,
    userClosedDevices: !open
  }
  saveBrowserState(state.isSidebarOpen, newState.isDevicesOpen)
  return newState
})

export function loadBrowserState(userSettings: any) {
  if (!userSettings?.browserStates) return

  const browserId = getBrowserId()
  const browserState = userSettings.browserStates[browserId]

  if (browserState) {
    uiState.update(state => ({
      ...state,
      isSidebarOpen: browserState.sidebarOpen,
      isDevicesOpen: browserState.devicesOpen
    }))
  }
}